import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

// action creators
import { booksShow } from '../../../actions/booksActions';
import { doctorListFetchForOffice } from '../../../actions/doctorActions';

// components
import { Panel, PanelBody, PanelHeader } from '../../shared/_panel';
import Spinner from '../../shared/_Spinner';
import Advertisement from '../../shared/_advertisement';

// lib
import formatPhoneNumber from '../../../lib/formatPhoneNumber';
import PremiumFeature from '../../shared/PremiumFeature';

class Show extends React.Component {
  static propTypes = {
    books:        PropTypes.instanceOf(Immutable.Map),
    doctor:       PropTypes.instanceOf(Immutable.Map),
    fetchDoctors: PropTypes.func.isRequired,
    showBooks:    PropTypes.func.isRequired
  };

  componentWillMount() {
    const { books, params: { id } } = this.props;

    const book = (books.get('data') || Immutable.Map()).get(id);

    if (!book) {
      this._initBook(this.props);
    }

    this._initDoctors(id);
  }

  render() {
    const { books, params: { id } } = this.props;

    const book    = (books.get('data') || Immutable.Map()).get(id) || Immutable.Map();
    const manager = book.get('manager') || Immutable.Map();

    return (
      <div className='body__content body__content--center rep-books-show'>
        <Panel>
          <Advertisement />
          <PanelHeader>
            <div className='rep-books-show__header__left-container'>
              <i className='fa fa-times-circle rep-books-show__header__back-button' onClick={ this._handleGoBack } />
            </div>
            <div className={ 'rep-apts__header' }>{ book.get('name') }</div>
          </PanelHeader>

          <PanelHeader className='rep-books-show__sub-header'>
            Details
          </PanelHeader>

          <Spinner enabled={ books.get('loading') }>
            <PanelBody className={ 'rep-books-show__panel-body' }>
              <div className='rep-books-show__body__container'>
                <div className='rep-books-show__body__label'>Address</div>
                <div>{ book.get('address') }</div>
                <div>{ `${book.get('city')}, ${book.get('state')} ${book.get('postalCode')}` }</div>
                <div>{ formatPhoneNumber(book.get('phoneNumber')) }</div>
              </div>

              <div className='rep-books-show__body__container'>
                <div className='rep-books-show__body__label'>Booking Manager</div>
                <div>{ manager.get('name') }</div>
              </div>

              <div className='rep-books-show__body__container'>
                <div className='rep-books-show__body__label'>Scheduling guidelines and restrictions</div>
                <div>{ book.get('guidelines') }</div>
              </div>
              <PremiumFeature premiumComponent={ <div className='rep-books-show__body__container'>
                <div className='rep-books-show__body__label'>Next opening date</div>
                <div>{book.get('openingInfo')}</div>
              </div> } />
              <div className='rep-books-show__body__container'>
                <div className='rep-books-show__body__label'>Doctors</div>

                { this._renderDoctors() }
              </div>
            </PanelBody>
          </Spinner>
        </Panel>
      </div>
    );
  }

  // private

    _handleGoBack = this._handleGoBack.bind(this)

    _initBook() {
      const { showBooks, params: { id } } = this.props;
      const params = {
        id
      };

      showBooks(params);
    }

    _initDoctors(officeId) {
      const { fetchDoctors } = this.props;

      fetchDoctors({ officeId: officeId });
    }

    _renderDoctors() {
      const { doctor } = this.props;

      const doctors   = doctor.get('data') || Immutable.Map();
      const result    = doctor.get('result') || Immutable.List();
      const elements  = [];

      result.forEach((doctorId) => {
        const d         = doctors.get(doctorId) || Immutable.Map();
        const schedule  = d.get('currentWeeklySchedule') || Immutable.Map();

        elements.push(
          <div key={ doctorId }>
            <div className='rep-books-show__body__doctor-name'>{ d.get('name')} {this._renderDoctorSchedule(schedule)} </div>
            <div className='rep-books-show__body__doctor-email'>{ d.get('email') }</div>
          </div>
        );
      });

      return elements;
    }

    _renderDoctorSchedule(schedule) {
      const shortSchedule = [];

      if (schedule.get('monday')) shortSchedule.push('M');
      if (schedule.get('tuesday')) shortSchedule.push('T');
      if (schedule.get('wednesday')) shortSchedule.push('W');
      if (schedule.get('thursday')) shortSchedule.push('R');
      if (schedule.get('friday')) shortSchedule.push('F');

      return `(${shortSchedule.join('')})`;
    }

    _handleGoBack() {
      if (!document.referrer || document.referrer === '') {
        return browserHistory.push('/reps/books');
      }
      return browserHistory.goBack();
    }
}

const mapStateToProps = (state) => {
  return {
    books:  state.get('books'),
    doctor: state.get('doctor')
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showBooks: (params) => dispatch(booksShow(params)),

    fetchDoctors: (params) => {
      dispatch(doctorListFetchForOffice(params));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Show);



// WEBPACK FOOTER //
// ./app/components/reps/books/Show.jsx